// material-ui
import { Stack, Typography } from '@mui/material';
import zignaaiLogo from 'assets/images/zignaai_logo.png';
import prodLogo from 'assets/images/logo_sutherland.png';
import { Link } from 'react-router-dom';

const Footer = () => (
  <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ p: '24px 16px 0px', mt: 'auto' }}>
    <Typography>
      <Typography variant="caption">&copy; Copyright 2025</Typography>
      <Typography variant="caption">
        {' '}
        <Link style={{ textDecoration: 'none', color: '#6b3381' }} to="https://www.zignaai.com">
          ZignaAI
        </Link>
      </Typography>
    </Typography>
    <Stack spacing={1.5} direction="row" justifyContent="space-between" alignItems="center" sx={{ heigh: '30px' }}>
      {/* <Typography>
        Environment : {import.meta.env.VITE_ENVIRONMENT}
      </Typography>
      <Typography>
        Version : {import.meta.env.VITE_PROJECT_VERSION}
      </Typography> */}
      <Typography>
        <img src={import.meta.env.VITE_ENVIRONMENT === 'PROD' ? prodLogo : zignaaiLogo} alt="logo" width={80} />
      </Typography>
    </Stack>
  </Stack>
);

export default Footer;
